import { makeWidgetsList, CoreProvider, selectRootWidgetUids, useAppSelector } from '@libs/core';
import Widget from './Widget';

const WidgetsList = makeWidgetsList(Widget);

export function App() {
    const rootWidgetUids = useAppSelector(selectRootWidgetUids);

    return (
        <CoreProvider>
            <WidgetsList uids={rootWidgetUids} />
        </CoreProvider>
    );
}
